import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';
//import ProductList from '../Theme/ProductList';
import ProductGrid from '../CategoryPage/ProductGrid';

export const SectionHeading = styled('h3')`
  ${({ theme }) => theme.typography.h3};
  margin-bottom: 3rem;
  text-align: center;
`;

const BreakFlex = styled('div')`
  flex: 1 1 100%;
  width: 100%;
`;

const SectionRow = styled('div')`
  ${({ theme }) => theme.elements.fwContainer};
  background: ${({ theme }) => theme.colors.grey};
  padding: 2.75rem 0;

  ${({ theme }) => theme.below.md} {
    padding-bottom: ${({ theme }) => theme.space[2]};
  }
`;

const SectionRowInner = styled('div')`
  ${({ theme }) => theme.elements.container};
  //display: flex;
  //flex-wrap: wrap;
  //justify-content: flex-start;

  ${({ theme }) => theme.below.md} {
    //padding: 0;
    margin: 0 auto;
    overflow: hidden;
    padding: 0 8px;
    & > a {
      display: inline-block;
      width: 50%;
      padding: 0 8px;
      margin: 0;
      margin-bottom: 30px;
      float: left;
    }
  }
`;

const RelatedProducts = ({ relatedProducts }) => {
  return relatedProducts && relatedProducts.length ? (
    <BreakFlex>
      <SectionRow>
        <SectionHeading>{t('Related products')}</SectionHeading>
        <SectionRowInner>
          <ProductGrid products={relatedProducts} />
        </SectionRowInner>
      </SectionRow>
    </BreakFlex>
  ) : null;
};

export default RelatedProducts;
